<template>
  <div
    class="main-menu menu-fixed menu-accordion menu-shadow"
    :class="[
      {
        expanded:
          !isVerticalMenuCollapsed ||
          (isVerticalMenuCollapsed && isMouseHovered),
      },
      skin === 'semi-dark' ? 'menu-dark' : 'menu-light',
      $store.state.app.isAdmin ? 'admin-menu' : '',
    ]"
    @mouseenter="updateMouseHovered(true)"
    @mouseleave="updateMouseHovered(false)"
  >
    <!-- main menu header-->
    <div class="navbar-header expanded" style="margin-bottom: 50px;">
      <slot
        name="header"
        :toggleVerticalMenuActive="toggleVerticalMenuActive"
        :toggleCollapsed="toggleCollapsed"
        :collapseTogglerIcon="collapseTogglerIcon"
      >
        <ul class="nav navbar-nav flex-row">
          <!-- Logo & Text -->
          <li class="nav-item mr-auto">
            <b-link class="navbar-brand" :to="logoHomeRoute">
              <!-- <span class="brand-logo">
                <b-img
                  :src="logoProductCatalog"
                  alt="logo"
                />
              </span> -->
              <h2 class="brand-text">
                <b-img
                  :src="logoProductCatalog"
                  alt="logo"
                  style="width: 100%;"
                />
              </h2>
            </b-link>
          </li>

          <!-- Toggler Button -->
          <!-- <li class="nav-item nav-toggle">
            <b-link class="nav-link modern-nav-toggle">
              <feather-icon
                icon="XIcon"
                size="20"
                class="d-block d-xl-none"
                @click="toggleVerticalMenuActive"
              />
              <feather-icon
                :icon="collapseTogglerIconFeather"
                size="20"
                class="d-none d-xl-block collapse-toggle-icon"
                @click="toggleCollapsed"
              />
            </b-link>
          </li> -->
        </ul>
      </slot>
    </div>
    <!-- / main menu header-->

    <!-- Shadow -->
    <div :class="{ 'd-block': shallShadowBottom }" class="shadow-bottom" />

    <!-- main menu content-->
    <vue-perfect-scrollbar
      :settings="perfectScrollbarSettings"
      class="main-menu-content scroll-area"
      tagname="ul"
      @ps-scroll-y="
        evt => {
          shallShadowBottom = evt.srcElement.scrollTop > 0
        }
      "
    >
      <vertical-nav-menu-items
        :items="$store.state.app.isAdmin ? adminNavItem : userNavItem"
        class="navigation navigation-main"
        :class="[$store.state.app.isAdmin ? 'admin-nav' : '']"
      />
    </vue-perfect-scrollbar>
    <!-- /main menu content-->
  </div>
</template>

<script>
import { userNavItem, adminNavItem } from '@/navigation/vertical'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { BLink, BImg } from 'bootstrap-vue'
import { provide, computed, ref } from '@vue/composition-api'
import useAppConfig from '@core/app-config/useAppConfig'
import { $themeConfig } from '@themeConfig'
import VerticalNavMenuItems from './components/vertical-nav-menu-items/VerticalNavMenuItems.vue'
import useVerticalNavMenu from './useVerticalNavMenu'

export default {
  components: {
    VuePerfectScrollbar,
    VerticalNavMenuItems,
    BLink,
    BImg,
  },
  props: {
    isVerticalMenuActive: {
      type: Boolean,
      required: true,
    },
    toggleVerticalMenuActive: {
      type: Function,
      required: true,
    },
  },
  setup(props) {
    const {
      isMouseHovered,
      isVerticalMenuCollapsed,
      collapseTogglerIcon,
      toggleCollapsed,
      updateMouseHovered,
    } = useVerticalNavMenu(props)

    const { skin } = useAppConfig()

    // Shadow bottom is UI specific and can be removed by user => It's not in `useVerticalNavMenu`
    const shallShadowBottom = ref(false)

    provide('isMouseHovered', isMouseHovered)

    const perfectScrollbarSettings = {
      maxScrollbarLength: 60,
      wheelPropagation: false,
    }

    const collapseTogglerIconFeather = computed(() =>
      collapseTogglerIcon.value === 'unpinned' ? 'CircleIcon' : 'DiscIcon'
    )

    // App Name
    const { appName, appLogoImage } = $themeConfig.app

    return {
      userNavItem,
      adminNavItem,
      perfectScrollbarSettings,
      isVerticalMenuCollapsed,
      collapseTogglerIcon,
      toggleCollapsed,
      isMouseHovered,
      updateMouseHovered,
      collapseTogglerIconFeather,

      // Shadow Bottom
      shallShadowBottom,

      // Skin
      skin,

      // App Name
      appName,
      appLogoImage,
    }
  },

  data() {
    return {
      logoProductCatalog: require('@/assets/images/logo-prod.png'),
      // logoProductCatalog: require('@/assets/images/Prod.png'),
      logoAdminProductCatalog: require('@/assets/images/logo-admin-putih.png'),
    }
  },
  computed: {
    logoProductCatalog: function() {
      return this.$store.state.app.settings.logo.menu ?? '/img/catalog_logo.png'
    },
    logoHomeRoute() {
      return this.$store.state.app.isAdmin
        ? { name: 'admin-dashboard' }
        : { name: 'home' }
    },
    allowedAdminRoutes() {
      const userCurrentRole = this.$store.getters['oauth/getActiveUser']?.role ?? []
      const data = this.adminNavItem ?? []
      return this.checkRole(data, userCurrentRole)
    }
  },
  mounted() {},
  methods: {
    checkRole(routes, userCurrentRole) {
      return routes.reduce((pre, curr) => {
        if (curr.children && curr.children.length > 0) {
          curr.children = this.checkRole(curr.children, userCurrentRole)
        }
        if (!curr.role || curr.role === '' || curr.role === null) {
          pre.push(curr)
        }
        const can = (curr?.role?.split(',') ?? []).reduce((pre2, curr2) => {
          if (pre2 === true) {
            return true
          } else {
            return userCurrentRole.includes(curr2)
          }
        }, false)
        if (can) {
          pre.push(curr)
        }
        return pre
      }, [])
    }
  }
}
</script>

<style scoped>
.admin-menu {
  background-color: #828282;
}
.admin-nav {
  background-color: #828282 !important;
}
</style>

<style lang="scss">
@import '~@core/scss/base/core/menu/menu-types/vertical-menu.scss';
</style>
